"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _SnackbarContent = _interopRequireDefault(require("@material-ui/core/SnackbarContent"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function TransitionUp(props) {
  return /*#__PURE__*/_react.default.createElement(_Slide.default, _extends({
    direction: "up"
  }, props));
}
function TransitionDown(props) {
  return /*#__PURE__*/_react.default.createElement(_Slide.default, _extends({
    direction: "down"
  }, props));
}
class SnackBarRoot extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      message: '',
      time: 0
    });
    _defineProperty(this, "onClose", (e, reason) => {
      if (reason !== 'clickaway') {
        this.setState({
          message: ''
        });
      }
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.time > this.props.time) {
      this.setState({
        message: nextProps.message
      });
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
      key: 'why-do-i-need-a-key',
      open: Boolean(this.state.message),
      onClose: this.onClose,
      autoHideDuration: this.props.autoHideDuration,
      TransitionComponent: this.props.top ? TransitionDown : TransitionUp,
      anchorOrigin: {
        vertical: this.props.top ? 'top' : 'bottom',
        horizontal: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement(_SnackbarContent.default, {
      action: this.props.spinner ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
        color: "secondary",
        thickness: 8
      }) : /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        key: "close",
        color: "secondary",
        onClick: this.onClose
      }, /*#__PURE__*/_react.default.createElement(_Close.default, null)),
      message: this.state.message
    }));
  }
}
exports.default = SnackBarRoot;
_defineProperty(SnackBarRoot, "propTypes", {
  message: _propTypes.default.string,
  top: _propTypes.default.bool,
  spinner: _propTypes.default.bool,
  autoHideDuration: _propTypes.default.number
});
_defineProperty(SnackBarRoot, "defaultProps", {
  top: false,
  spinner: false
});